module.exports = __webpack_public_path__ + "img/development-during-recession-top.d166dc5c.jpeg";